import { render, staticRenderFns } from "./PortfolioToggle.vue?vue&type=template&id=88d9c7ce&"
import script from "./PortfolioToggle.vue?vue&type=script&lang=js&"
export * from "./PortfolioToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports